import axios from "axios"

const state = {
    wallets: [],
}

const getters = {
    GetAdminWallets: (state) => state.wallets,
}

const actions = {
    async ActionGetAdminWallets({ commit }) {
        try {
            const response = await axios.get('/api/admin/wallet/system').then(res => res.data)
            if(response && response.data) {
                try {
                    commit('SetAdminWallets', response.data)
                } catch (e) {
                    console.error('Error committing wallets to state:', e)
                }
                return response.data
            }
        } catch (error) {
            console.error('Error fetching wallets:', error)
            return []
        }
    },
}

const mutations = {
    SetAdminWallets: (state, wallets) => (state.wallets = wallets),
}

export default {
    state,
    getters,
    actions,
    mutations,
}